<template>
  <div id="epaper_index">
    <template v-if="is_xhn">
        <div class="epaper_nav">
          <div @click="change_num(0)">
              <img v-show="sel_num!=0" src="../assets/img/index/page1@2x.png" alt="">
              <img v-show="sel_num==0" src="../assets/img/index/page2@2x.png" alt="">
          </div>
          <div @click="change_num(1)">
              <img v-show="sel_num!=1" src="../assets/img/index/list1@2x.png" alt="">
              <img v-show="sel_num==1" src="../assets/img/index/list2@2x.png" alt="">
          </div>
          <div @click="date_show = true">
              <!-- <datepicker :date="datetime" :option="multiOption" :limit="limit"></datepicker> -->
              <img src="../assets/img/index/date1@2x.png" alt="">
          </div>
          <ul @click="sel_mask = false" v-show="sel_mask" class="epaer_select">
              <li @click="swiperTo(index)" :key="index" v-for="(item,index) in paper_list">
                  <p>{{item.BC+item.BM}}</p>
              </li>
          </ul>
      </div>
      <div class="epaper_bank">

      </div>
      <div v-show="sel_num == 0" class="swiper_box">
        <!-- @touchstart="getTouchStart(item)" @touchend="getTouchEnd" -->
        <Swiper class="swiper_content" ref="paperswiper" :options="swiperOption">
            <Swiper-slide :key="index" v-for="(item,index) in paper_list">
                <img  @click="articleTo(item)" v-lazy="item.ImageSrc" class="paper_img" :usemap="'#BM'+index"  alt />
                <map  v-if="paper_loading" :name="'BM'+index">
                    <area href="javascript:;" shape="poly" @click="areaClick(imgs)" :key="'area_'+index" v-for="(imgs,index) in item.Articles" :coords="area(imgs.ZB)">
                </map>
            </Swiper-slide>
        </Swiper>
        <!-- <div @touchstart.passive="touchs_fn" @touchmove.passive="touchm_fn" @touchend.passive="touche_fn" class="swiper_content">
            <template  v-for="(item,index) in paper_list">
                <img ref="img_dom" v-show="index==page_num"  @click="articleTo(item)" :src="item.ImageSrc" class="paper_img" :usemap="'#BM'+index"  alt />
                <map  v-if="paper_loading" v-show="index==0" :name="'BM'+index">
                    <area href="javascript:;" shape="poly" @click="areaClick(imgs)" :key="'area_'+index" v-for="(imgs,index) in item.Articles" :coords="area(imgs.ZB)">
                </map>
            </template>
        </div>
        <Flipbook v-if="show_filpbook" ref="filpbook" :startPage="startPage" @flip-left-end="onFlipEnd"  @flip-right-end="onFlipEnd" :zooms="null" class="flipbook" :pages="img_list">
        </Flipbook> -->
      </div>
      <div v-if="sel_num == 1">
          <ul class="epaper_catalog">
              <li :key="'catalog'+index" v-for="(item,index) in paper_list">
                  <div @click="sel_li(index,(item.Articles?item.Articles.length:0))" class="epaper_title">
                      <p>{{item.BC+item.BM}}</p>
                      <i style="transform:rotate(0deg);" :ref="'epaper_rotate'+index"></i>
                  </div>
                  <ul :style="'height:'+1.066667*(item.Articles?item.Articles.length:0)+'rem;'" :ref="'eaer_li'+index" class="eaper_li">
                      <li @click="areaClick(items)" :key="'eaper_li'+indexs" v-for="(items,indexs) in item.Articles">
                          <p>{{items.BT}}</p>
                      </li>
                  </ul>
              </li>
          </ul>
      </div>
      <div v-if="img_dialog" class="img_dialog">
          <div class="img_nav">
              <div @click="img_dialog = false"> 
                  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAkCAMAAAC+LeqSAAAAclBMVEVHcEz///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9wvwjfAAAAJXRSTlMAg/qR/XVaymf+9wFD8545A6owBbbpE9snCSANwOJPTsPMGe/uPk0CagAAAKJJREFUKM+N0scOwjAQBFCnOt3pvQDJ/P8vgsJtvEj4+CTL491Ris/r+bBsHqDZxg26J6s7rAuZOdFOZFmOqiHbExQlWejCS8kiHw5nCeI4YHPgR0SpBzckKwskB1lTIc/IphaXIVtWdDVZr7GNnEVjmNVfKF4XH7ojncZSKfz3m7ul0kDk0f0YsrwOeXFKHcKK5TJ8anPZtZELJldRLu1d7zetLg1X5MBlkQAAAABJRU5ErkJggg==" alt="">
              </div>
          </div>
          <Swiper class="img_swiper" :options="swiperOption1">
            <Swiper-slide>
                <div class="swiper-zoom-container">
                     <img :src="imgSrc" alt="">
                </div>
            </Swiper-slide>
        </Swiper>
      </div>
      <!-- 日期弹窗 -->
    <van-popup position="bottom" v-model="date_show">
        <van-datetime-picker
            v-model="currentDate"
            type="date"
            title="选择年月日"
            :min-date="minDate"
            :max-date="maxDate"
            @cancel="date_show = false"
            @confirm="date_confirm"
        />
    </van-popup>
    <div ref="poster_dom" v-if="reload_poster" class="poster_dom">
        <img class="poster_icon" v-if="page_title != '三湘都市报'" src="@/assets/img/poster_icon.png" alt="" srcset="">
        <img class="poster_icon" v-else src="@/assets/img/poster_icon_sxdsb.png" alt="" srcset="">
        <img class="poster_content" :src="poster_image" alt="" srcset="">
        <div class="poster_bottom">
            <div class="poster_time_box">
                <p>{{getCurrentYearMonth(currentDate)}}</p>
                <h1>
                    {{getCurrentDay(currentDate)}}
                </h1>
                <span>- {{getCurrentWeekday(currentDate)}} -</span>
            </div>
            <div class="qrcode_box">
                <div>
                    <h1>
                        长按查看原文
                    </h1>
                    <p>分享自@新湖南客户端</p>
                </div>
                <div class="qrcode_img">
                    <img src="@/assets/img/qr_icon.png" alt="" srcset="">
                    <qrcode  class="qrcode_img" :value="qrcode_option.value" :options="{ width: 60 }"></qrcode>
                </div>
                
                <!-- <qrcode-vue 
                    class="qrcode_img"
                    :size="qrcode_option.size" 
                    :value="qrcode_option.value" 
                    :bgColor="qrcode_option.bgColor" 
                    :fgColor="qrcode_option.fgColor"
                ></qrcode-vue> -->
            </div>
        </div>
    </div>
    </template>
  </div>
</template>

<script>
import datepicker from 'vue-datepicker'
import 'swiper/css/swiper.css';
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import {mapState} from 'vuex'
import qrcodeVue from 'qrcode-vue'
import qrcode from '@chenfengyuan/vue-qrcode';
import Flipbook from 'flipbook-vue/dist/vue2/flipbook.cjs'
import html2canvas from 'html2canvas'
let self
export default {
    data(){
        return{
            page_title:process.env.VUE_APP_PAPERTITLE,
            swiper_current_index:0,
            qrcode_option:{
                size: 60,
                bgColor: '#fff',
                fgColor: '#000',
                value: 'https://usergrow-xhncloud.voc.com.cn/static/app/qrcode_jump.html?secondpath=xinhunan&pkgname=com.dingtai.wxhn.activity&scheme=xhn%3A%2F%2FopenNewsPaperPage',
            },
            sel_num:0,
            swiperOption: {
                //swiper3
                // speed: 1000,
                on:{
                    slideChangeTransitionEnd: function(){
                        self.swiper_current_index = this.activeIndex
                    },
                }
            },
            swiperOption1:{
                zoom:true
            },
            paper_list:[],
            show_img_list:false,
            img_list:[],
            paper_loading:false,
            sel_mask:false,
            datetime:{
                time:''
            },
            multiOption: {
                type: 'day',
                week: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
                month: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
                format:"YYYY/MM/DD",
                inputStyle: {
                'display': 'inline-block',
                'padding': '6px',
                'line-height': '22px',
                'width':'100%',
                'font-size': '16px',
                'border': '2px solid #fff',
                'box-shadow': '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
                'border-radius': '2px',
                'color': '#5F5F5F',
                'margin':'0',
                'position':'absolute',
                'top':'0',
                'right':'0',
                'opacity':'0',
                },
                buttons: {				// button 文案
                ok: '确定',
                cancel: '取消'
                },
                placeholder: '请选时间',
                dismissible: true,
            },
        limit: [
		    {
		        type: 'fromto',
		        from: '2016/01/31',
		        to: '2050/02/20'
        }],
        sufu:{},
        imgSrc:'',
        img_dialog:false,
        timer:{},
        page_num:0,
        startPage:1,
        show_filpbook:true,
        date_show:false,
        minDate: new Date(2020, 0, 1),
        maxDate: new Date(2025, 10, 1),
        currentDate: new Date(2021, 0, 17),
        poster_image:'',
        reload_poster:false,
        }
    },
    computed:{
        ...mapState(['is_xhn'])
    },
  activated(){
  document.title = this.$store.state.papertitle;
  window['startPaperShare'] = async () =>{
    this.poster_image = await this.imageUrlToBase64(this.paper_list[this.swiper_current_index].ImageSrc)
    this.reload_poster = false;
        this.$nextTick(() => {
            this.reload_poster = true
            setTimeout(() => {
                html2canvas(this.$refs['poster_dom']).then(function(canvas) {
                    console.log(canvas.toDataURL('image/jpeg'))
                let post_data = {
                    "share_title": "",
                    "share_des": "",
                    "share_img": canvas.toDataURL('image/jpeg'),
                    "share_url": "",
                    "content_type": "3",
                    "poster_img": '',
                    "share_type": "0"
                }
                vmobile.beginCutomerShare(JSON.stringify(post_data))
            });
            },500);
        });
  }
  },
    mounted(){
        self = this
        if(!this.is_xhn){
            console.log(this.$toast('请在新湖南客户端内打开'))
        }
        this.currentDate = new Date()
        this.datetime.time = this.dateFormat(new Date());
        // this.getrb(new Date(this.datetime.time).getTime());
        //     this.$refs['paperswiper'].$swiper.slideTo(0, 1000, true);
        this.$store.state.api.gethasday()
        .then(res=>{
            if(res.length == 2){
                let dateTime = new Date(res[0].replace(/-/g,'/') + ' 00:00:00');
                dateTime =  dateTime.setDate(dateTime.getDate());
                dateTime = new Date(dateTime);
                this.minDate = dateTime
                this.maxDate = new Date(res[1].replace(/-/g,'/') + ' 23:59:59'); 
                console.log(this.maxDate)
                console.log(this.minDate)
                this.limit[0].from = dateTime;
                this.limit[0].to = res[1].replace(/-/g,'/') + ' 23:59:59'; 
            }
        })
    },
    components: {
        Swiper,
        SwiperSlide,
        datepicker,
        Flipbook,
        qrcodeVue,
        qrcode
    },
    methods:{
        getCurrentYearMonth(date) {
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 补0
            return `${year}/${month}`;
        },
        getCurrentDay(date) {
            const day = date.getDate().toString().padStart(2, '0'); // 补0
            return day;
        },
        getCurrentWeekday(date) {
            const weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
            return weekdays[date.getDay()];
        },
        date_confirm(value){
            this.startPage = 1
            this.page_num = 0
            this.show_filpbook = false;
            this.date_show = false
            this.$nextTick(()=>{
                this.show_filpbook = true;
            })
            this.getrb(new Date(value).getTime());
        },
        preventBounceScroll() {
            let startY = 0;
            function handleTouchMove(event) {
                event.preventDefault();
                const touch = event.touches[0];
                const deltaY = startY - touch.clientY;
                startY = touch.clientY;

                const element = event.target;
                const scrollable = element.scrollHeight > element.clientHeight;
                const atTop = element.scrollTop === 0;
                const atBottom = element.scrollHeight - element.scrollTop === element.clientHeight;

                if (scrollable && ((atTop && deltaY > 0) || (atBottom && deltaY < 0))) {
                    event.stopPropagation();
                }
            }

            function handleTouchStart(event) {
                const touch = event.touches[0];
                startY = touch.clientY;
            }

            document.addEventListener('touchmove', handleTouchMove, { passive: false });
            document.addEventListener('touchstart', handleTouchStart, { passive: false });
        },
        onFlipEnd(page){
            this.page_num = page-1
        },
        simulateTouchEvent(targetElement,eventType, x, y) {//模拟touch事件
            const touch = new Touch({
                identifier: Date.now(),
                target: targetElement,
                clientX: x,
                clientY: y,
                screenX: x,
                screenY: y,
                pageX: x,
                pageY: y
            });

            const touchEvent = new TouchEvent(eventType, {
                touches: [touch],
                targetTouches: [touch],
                changedTouches: [touch],
                bubbles: true,
                cancelable: true,
                composed: true
            });
            touchEvent.preventDefault();
            targetElement.dispatchEvent(touchEvent);
        },
        touchs_fn(e){
            let dom = document.getElementsByClassName('bounding-box')[0]
            this.simulateTouchEvent(dom,'touchstart',e.touches[0].clientX,e.touches[0].clientY)
        },
        touchm_fn(e){
            let dom = document.getElementsByClassName('bounding-box')[0]
            this.simulateTouchEvent(dom,'touchmove',e.touches[0].clientX,e.touches[0].clientY)
        },
        touche_fn(e){
            let dom = document.getElementsByClassName('bounding-box')[0]
            this.simulateTouchEvent(dom,'touchend',e.changedTouches[0].clientX,e.changedTouches[0].clientY)
        },
        articleTo(item){
            if(item.Articles&&item.Articles.length == 0){
                // let post_json = {
                //     'index':0,img_dialog
                //     'photos':[item.ImageSrc]
                // };
                // post_json = JSON.stringify(post_json)
                // vmobile.openPhotoFromNative(post_json)
                this.imgSrc = item.ImageSrc;
                this.img_dialog = true;
            }
        },
        getTouchStart(item){
            clearTimeout(this.sufu);
            this.sufu=setTimeout(()=>{
                this.imgSrc = item.ImageSrc;
                this.img_dialog = true;
                //  你要做的功能
            },500);
        },
        getTouchEnd(){
            clearTimeout(this.sufu);
        },
        getrb(date){
            this.$store.state.api.getpaper({date})
            .then(res=>{
                if(res){
                    this.paper_list = res;
                    this.img_list = this.paper_list.map((item)=>item.ImageSrc)
                    this.$nextTick(()=>{
                        this.show_img_list = true
                    })
                    let imgurl = res[0].ImageSrc;
                    let promiseImg = new Promise((resolve,reject)=>{
                        const img = new Image();
                        img.src = imgurl;
                        img.onload = ()=> resolve(imgurl);
                        img.onerror = ()=>reject(imgurl)
                    });
                    promiseImg.then(res=>{
                        setTimeout(() => {
                            this.paper_loading = true;
                        },500);
                    }).catch(err=>{
                        setTimeout(() => {
                            this.paper_loading = true;
                        },500);
                    })
                }
            });
        },
        change_num(num){
            if(num == 0&&this.sel_num == 0){
                this.sel_mask = true;
                return;
            }
             this.sel_mask = true;
             this.$nextTick(() => {
                 this.sel_mask = false;
             })
            this.sel_num = num
            this.show_filpbook = false
            this.startPage = 1
            this.page_num = 0
            this.$nextTick(()=>{
                this.show_filpbook = true
            })
        },
        area(ZB){
            var array = [];
            var width=window.innerWidth;
            var Height=document.getElementsByClassName('paper_img')[0].scrollHeight;
            if(Height == 0) {
                Height = Math.round(width*1.53);
            }     
            // $rootScope.mapwidth=$window.innerWidth;
            // $rootScope.mapheight=Height;
            ZB=ZB.replace(new RegExp(/></ig),',').replace(new RegExp(/%/ig),'').replace('<','').replace('>','').split(',');
            for(var i=0;i<ZB.length;i++)
            {
                array.push(parseInt((ZB[i]*(i%2==0?width:Height))/100));
            }
            return array.join(',');
        },
        areaClick(imgs){
            if(this.isXinhunan){
                let newsUrl = `https://h5cgi.voc.com.cn${process.env.VUE_APP_STATICURL}/#/detail?kid=`+imgs.KY;
                vmobile.openUrl(imgs.BT,newsUrl);
            }else{
                this.$router.push({path:'/detail',query:{kid:imgs.KY}})
            }
        },
        swiperTo(index){
            this.$refs['paperswiper'].$swiper.slideTo(index, 1000, true);
            // if(this.$refs['filpbook'].page == index+1){
            //     return
            // }
            // let num = Math.abs(index+1 - this.$refs['filpbook'].page)
            // if(this.$refs['filpbook'].page<index+1){
            //     for (let index = 0; index < num; index++) {
            //         this.$refs['filpbook'].flipRight()
            //     }
            // }else{
            //     for (let index = 0; index < num; index++) {
            //         this.$refs['filpbook'].flipLeft()
            //     }
            // }
            this.page_num = index
            this.startPage = 0
            this.$nextTick(()=>{
                this.startPage = index+1
            })
            this.sel_mask = false;
        },
        sel_li(index,num){
            if(this.$refs['eaer_li'+index][0].style.height == '0px'){
                this.$refs['eaer_li'+index][0].style.height = 1.066667*num+'rem';
            }else{
                this.$refs['eaer_li'+index][0].style.height = 0+'px'
            };
            if(this.$refs['epaper_rotate'+index][0].style.transform == 'rotate(0deg)'){
                this.$refs['epaper_rotate'+index][0].style.transform = 'rotate(180deg)'
            }else{
                this.$refs['epaper_rotate'+index][0].style.transform = 'rotate(0deg)'
            }
        },
        dateFormat( date,fmt = 'YYYY/mm/dd') {
            let ret;
            const opt = {
                "Y+": date.getFullYear().toString(),        // 年
                "m+": (date.getMonth() + 1).toString(),     // 月
                "d+": date.getDate().toString(),            // 日
                "H+": date.getHours().toString(),           // 时
                "M+": date.getMinutes().toString(),         // 分
                "S+": date.getSeconds().toString()          // 秒
                // 有其他格式化字符需求可以继续添加，必须转化成字符串
            };
            for (let k in opt) {
                ret = new RegExp("(" + k + ")").exec(fmt);
                if (ret) {
                    fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
                };
            };
            return fmt;
        },
        imageUrlToBase64(img) {
            // 一定要设置为let，不然图片不显示
            let image = new Image();
            // 解决跨域问题
            image.crossOrigin = "Anonymous";
            let imageUrl = img;
            image.src = imageUrl;
            // image.onload为异步加载
            return new Promise((resolve, reject)=>{
                image.onload = () => {
                    resolve(this.getImage(image));
                };
                image.onerror = () =>{
                    resolve('');
                }
            })
        },
        getImage(image) {
            let canvas = document.createElement('canvas');
            canvas.width = image.width;
            canvas.height = image.height;
            let context = canvas.getContext('2d');
            context.drawImage(image, 0, 0, image.width, image.height);
            let quality = 0.8;
            let dataURL = canvas.toDataURL('image/png', quality);
            return dataURL
        }
    },
    watch:{
        'datetime.time':function (){
            this.startPage = 1
            this.page_num = 0
            this.show_filpbook = false;
            this.$nextTick(()=>{
                this.show_filpbook = true;
            })
            this.getrb(new Date(this.datetime.time).getTime());
            // this.$refs['paperswiper'].$swiper.slideTo(0, 1000, true);
        }
    }
}
</script>

<style lang="scss">
@import url(../assets/css/common.css);
.poster_dom{
    width: 600px;
    background: #FFFFFF;
    border-radius: 5px 5px 0px 0px;
    position: fixed;
    z-index: 999;
    padding-top: 32px;
    z-index: -1;
    left: 100000px;
    top: 1000000px;
    .poster_icon{
        height:50px;
        display: block;
        margin-bottom: 32px;
    }
    .poster_content{
        display: block;
        height: 940px;
        margin: auto;
        max-width: calc(100% - 76px);
    }
    .poster_bottom{
        width: 100%;
        padding: 0 32px 26px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 20px;
        .poster_time_box{
            display: flex;
            flex-direction: column;
            justify-content: center;
            color:#BD9348;
            line-height: 1;
            p{
                font-size: 24px;
                text-align:center;
            }
            h1{
                font-size:66px;
                text-align: center;
                line-height: 1;
            }
            span{
                font-size:24px;
                position: relative;
                line-height: 24px;
            }
        }
        &>img{
            width: 88px;
            height: 88px;
        }
        .qrcode_box{
            display: flex;
            align-items: center;
            margin-left: 10px;
            &>.qrcode_img{
                width: 129px!important;
                height: 129px!important;
                margin-left: 10px;
                position:relative;
                img{
                    width:56px;
                    height: 56px;
                    position:absolute;
                    left:50%;
                    top:50%;
                    transform: translate(-50%,-50%);
                }
                canvas{
                    width:100%!important;
                    height:100%!important;
                }
            }
            &>div{
                display: flex;
                flex-direction: column;
                text-align: right;
                align-items: flex-end;
                h1{
                    color: #505154;
                    font-size: 19px;
                    font-weight: normal;
                }
                p{
                    color: #9EA4A9;
                    font-size: 19px;
                    margin-top: 4px;
                }
            }
        }
    }
}
.viewport{
    -webkit-overflow-scrolling:inherit!important;
    overflow-x: hidden;
}
#epaper_index{
    width:100%;
    position: absolute;
    left: 0;
    top: 0;
    height: 100vh;
    display: flex;
    flex-direction: column;
    .swiper-slide{
        padding: 0 0.1rem;
        overflow-y: auto;
    }
    .img_dialog{
        width: 100%;
        height: 100vh;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 100;
        background: rgb(0,0,0);
        overflow: auto;
        .img_swiper{
            width: 100%;
            height: 100%;
        }
        .img_nav{
            width: 100%;
            height: 100px;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 101;
            div{
                width: 100px;
                height: 100px;
                display: table-cell;
                text-align: center;
                vertical-align: middle;
                background-size: .2rem;
                img{
                    width: 20px;
                }
            }
        }
    }
    .epaper_nav{
        position: fixed;
        width: 100%;
        background: #f8f8f8;
        left: 0;
        top: 0;
        height: 88px;
        z-index: 99;
        display: flex;
        justify-content: space-between;
        &>div{
            flex: 1;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            img{
                width: 100px;
                height: 28px;
            }
            &:last-child::before{
                display: none;
            }
            &::before{
                content: "";
                width: 1Px;
                height: 40px;
                position: absolute;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
                background: #e2e2e2;
            }
        }
        .epaer_select{
            position: absolute;
            width: 100%;
            height: calc(100vh - 88px);
            overflow-y: auto;
            top: 88px;
            background: rgba(0,0,0,0.5);
            flex-wrap: wrap;
            &>li{
                float: left;
                box-sizing: border-box;
                width: 33.33%;
                height: 112px;
                border-right: 1px solid #e9e9e9;
                border-bottom: 1px solid #e9e9e9;
                display: flex;
                justify-content: center;
                align-items: center;
                p{
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    color: white;
                    font-size: 32px;
                    font-weight: bold;
                }
            }
        }
    }
    .epaper_bank{
        width: 100%;
        height: 88px;
    }
    .swiper_box{
        flex: 1;
        position: relative;
        .swiper_content{
            position: absolute;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1;
            // *{
            //     overflow: hidden;
            // }
            img{
                width: 100%;
            }
        }
        img{
            width: 100%;
        }
        .flipbook{
            width: 100%;
            height: 100%;
            img{
                object-fit: contain;
            }
        }
    }
    .epaper_catalog{
        margin-top: 88px;
        .epaper_title{
            color: #e70012;
            width: 100%;
            height: 80px;
            background: #f8f8f8;
            border-bottom: 1px solid #e9e9e9;
            border-top: 1px solid #e9e9e9;
            padding: 0 50px 0 32px;
            font-size: 30px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            align-items: center;
            &>i{
                display: block;
                width: 20px;
                height: 10px;
                background: url(../assets/img/index/stop@2x.png)no-repeat;
                background-size: 100% 100%;
                transition: all 0.5s;
                transform: rotate(0deg);
            }
            p{
                flex: 1;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
            }
        }
        .eaper_li{
            width: 100%;
            line-height: 80px;
            overflow: hidden;
            transition: height 0.5s;
            &>li{
                padding: 0 32px;
                height: 80px;
                border-bottom: 1px solid #e9e9e9;
                :last-child{
                    border-bottom: none;
                }
            }
            p{
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            font-size: 28px;
        }
    }
}
</style>